import { render, staticRenderFns } from "./ButtonFacebook.vue?vue&type=template&id=28c4cc97&scoped=true&lang=pug&"
import script from "./ButtonFacebook.vue?vue&type=script&lang=js&"
export * from "./ButtonFacebook.vue?vue&type=script&lang=js&"
import style0 from "./ButtonFacebook.vue?vue&type=style&index=0&id=28c4cc97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c4cc97",
  null
  
)

export default component.exports